import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Checkbox, Input } from "antd"

const CheckboxGroup = Checkbox.Group

CheckboxInput.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.array,
}

function CheckboxInput(props) {

    const { checkedList, setCheckedList, errors, label, listQTY, setListQTY } = props
    const [indeterminate, setIndeterminate] = useState(false)
    const [checkAll, setCheckAll] = useState(false)
    const { listCheckBox } = props
    const onChange = (list) => {
        setCheckedList(list)
        setIndeterminate(!!list.length && (list.length < listCheckBox.length))
        setCheckAll(list.length > 0 && list.length === listCheckBox.length)
        if (!!list.length && (label === 'Branding' || label === 'Packaging')) {
            errors.brandRule = ''
        }
        if (!!list.length && label === 'All') {
            errors.orderType = ''
        }

    }

    const onCheckAllChange = (e) => {
        setCheckedList(e.target.checked ? listCheckBox.map(i => i.value) : [])
        setIndeterminate(false)
        setCheckAll(e.target.checked)
        if (label === 'Branding' || label === 'Packaging') {
            errors.brandRule = ''
        }
        if (label === 'All') {
            errors.orderType = ''
        }
    }

    useEffect(() => {
        if (typeof onChange === 'function') {
            onChange(checkedList)
        }
    }, [checkedList, indeterminate, listCheckBox])

    const handleInputChange = (e, id) => {
        const value = e.target.value;
        const sanitizedValue = value.replace(/[^0-9]|-/g, '').trim();

        setListQTY({
            ...listQTY,
            [id]: parseInt(sanitizedValue) ? parseInt(sanitizedValue) : null
        })
        if (errors.listQTY && errors.listQTY[id]) {
            delete errors.listQTY[id]
        }
    }

    const handleClick = (e) => {
        const value = e.target.value
        const check = e.target.checked
        if (!check && errors.listQTY && errors.listQTY[value]) {
            delete errors.listQTY[value]
        }
    }

    const handleClickLabel = (value) => {
        if (checkedList.includes(value)) {
            setCheckedList(checkedList.filter(i => i !== value))
            if (errors.listQTY && errors.listQTY[value]) {
                delete errors.listQTY[value]
            }
        } else {
            setCheckedList([...checkedList, value])
        }
    }

    const groupOptions = (label === 'Branding' || label === 'Packaging') ? [] : listCheckBox
    return (
        <div className="CheckboxInput mb-2">
            <div className="CheckAll mb-2">
                <Checkbox
                    indeterminate={indeterminate}
                    onChange={onCheckAllChange}
                    checked={checkAll}
                    disabled={!listCheckBox.length || listCheckBox.length <= 0}
                >
                    {label || 'All'}
                </Checkbox>
            </div>

            <div className="ListCheck ml-3">
                <CheckboxGroup options={groupOptions} className='' value={checkedList} onChange={onChange}>
                    <div className=' flex-wrap d-flex justify-content-between'>
                        {listCheckBox.length > 0 && listCheckBox.map((i, index) => (
                            <div className={`pr-3 mb-2`} key={index} style={{ width: '398px' }}>
                                <div className="d-flex align-items-center w-100 justify-content-between">
                                    <div className="Checkbox d-flex align-items-center">
                                        <Checkbox value={i.value} onClick={e => handleClick(e)}></Checkbox>
                                        <label
                                            className='mb-0 cursor-pointer'
                                            style={{ padding: '0 8px' }}
                                            onClick={() => handleClickLabel(i.value)}
                                        >
                                            {i.label}
                                        </label>
                                    </div>
                                    {(label === 'Branding' || label === 'Packaging') &&
                                        <div className="d-flex align-items-center">
                                            <label className='mb-0 mr-1'>Qty/product:</label>
                                            <Input
                                                type={'number'}
                                                key={i.value}
                                                value={listQTY && listQTY.hasOwnProperty(i.value) ? listQTY[i.value] : undefined}
                                                min={0}
                                                style={{ width: '70px' }}
                                                onChange={(e) => handleInputChange(e, i.value)}
                                            />
                                        </div>
                                    }
                                </div>
                                {!!errors.listQTY && errors.listQTY[i.value] &&
                                    <small className='text-danger d-block text-right mt-1'>{errors.listQTY[i.value]}</small>
                                }
                            </div>
                        ))}
                    </div>
                </CheckboxGroup>
            </div>

        </div>
    )
}

export default CheckboxInput
